const GetCommodityLandingReducer = (state = { type: 'LOADING_COMMODITY_MAIN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_COMMODITY_MAIN_ACTION':
            return action
        case 'RESET_COMMODITY_MAIN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetRISIDropdownReducer = (state = { type: 'LOADING_RISI_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_DROPDOWN_ACTION':
            return action
        case 'RESET_RISI_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetRISIDropdownV2Reducer = (state = { type: 'LOADING_RISI_DROPDOWN_V2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_DROPDOWN_V2_ACTION':
            return action
        case 'RESET_RISI_DROPDOWN_V2_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetRISISecondaryDropdownReducer = (state = { type: 'LOADING_RISI_SEC_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_SEC_DROPDOWN_ACTION':
            return action
        case 'RESET_RISI_SEC_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetRISISecondaryDropdownV2Reducer = (state = { type: 'LOADING_RISI_SEC_DROPDOWN_V2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_SEC_DROPDOWN_V2_ACTION':
            return action
        case 'RESET_RISI_SEC_DROPDOWN_V2_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetRISIDetailReducer = (state = { type: 'LOADING_RISI_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_DETAIL_VIEW_ACTION':
            return action
        case 'RESET_RISI_DETAIL_VIEW_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetRISIDetailV2Reducer = (state = { type: 'LOADING_RISI_DETAIL_VIEW_V2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RISI_DETAIL_VIEW_V2_ACTION':
            return action
        case 'RESET_RISI_DETAIL_VIEW_V2_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetNewsDropdownReducer = (state = { type: 'LOADING_NEWS_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NEWS_DROPDOWN_ACTION':
            return action
        case 'RESET_NEWS_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetNewsSecondaryDropdownReducer = (state = { type: 'LOADING_NEWS_SEC_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NEWS_SEC_DROPDOWN_ACTION':
            return action
        case 'RESET_NEWS_SEC_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetNewsDropdownDataReducer = (state = { type: 'LOADING_NEWS_DROPDOWN_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NEWS_DROPDOWN_DATA_ACTION':
            return action
        case 'RESET_NEWS_DROPDOWN_DATA_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetAllNewsListReducer = (state = { type: 'LOADING_ALL_NEWS_LIST_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_ALL_NEWS_LIST_ACTION':
            return action
        case 'RESET_ALL_NEWS_LIST_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetNewsDetailReducer = (state = { type: 'LOADING_NEWS_DETAIL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NEWS_DETAIL_ACTION':
            return action
        case 'RESET_NEWS_DETAIL_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetUpdateBookmarkReducer = (state = { type: 'LOADING_UPDATE_BOOKMARK_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_UPDATE_BOOKMARK_ACTION':
            return action
        case 'RESET_UPDATE_BOOKMARK_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


const GetBookmarkListReducer = (state = { type: 'LOADING_BOOKMARK_LIST_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_BOOKMARK_LIST_ACTION':
            return action
        case 'RESET_BOOKMARK_LIST_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetShareListReducer = (state = { type: 'LOADING_SHARE_LIST_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SHARE_LIST_ACTION':
            return action
        case 'RESET_SHARE_LIST_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetShareNewsEmailReducer = (state = { type: 'LOADING_SHARE_NEWS_EMAIL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SHARE_NEWS_EMAIL_ACTION':
            return action 
        default:
            return state
    }
}
export {
    GetCommodityLandingReducer,
    GetRISIDropdownReducer,
    GetRISIDropdownV2Reducer,
    GetRISIDetailReducer,
    GetRISIDetailV2Reducer,
    GetRISISecondaryDropdownReducer,
    GetRISISecondaryDropdownV2Reducer,
    GetNewsDropdownReducer,
    GetNewsSecondaryDropdownReducer,
    GetNewsDropdownDataReducer,
    GetAllNewsListReducer,
    GetNewsDetailReducer,
    GetUpdateBookmarkReducer,
    GetBookmarkListReducer,
    GetShareListReducer,
    GetShareNewsEmailReducer
}